import { NavLink } from "react-router-dom";
import React, { useState } from "react";

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <nav className={`nav ${open ? "open" : ""}`} aria-label="Main navigation">
      <h2>TimeSpark</h2>
      <button
        className="menu-btn"
        aria-expanded={open}
        aria-label={open ? "Close menu" : "Open menu"}
        onClick={() => setOpen((s) => !s)}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 6h18M3 12h18M3 18h18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div className="nav-links">
        <NavLink to="/" end>
          Home
        </NavLink>
        <NavLink to="/calendars">Calendars</NavLink>
        <NavLink to="/contracts">Contracts</NavLink>
        <NavLink to="/projections">Projections</NavLink>
        <NavLink to="/import-export">Import/Export</NavLink>
      </div>
    </nav>
  );
}
